import { DEFAULT_MARKETPLACE_LOCATION } from "../config/indianCities";

const STORAGE_KEY = "nema_marketplace_search_location_v1";

export function readPersistedMarketplaceLocation() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const label = String(parsed?.label || "").trim();
    const latitude = parsed?.latitude != null ? String(parsed.latitude).trim() : "";
    const longitude = parsed?.longitude != null ? String(parsed.longitude).trim() : "";
    if (!label || !latitude || !longitude) return null;
    if (!Number.isFinite(Number(latitude)) || !Number.isFinite(Number(longitude))) return null;
    return { label, latitude, longitude };
  } catch {
    return null;
  }
}

export function persistMarketplaceLocation({ label, latitude, longitude }) {
  const nextLabel = String(label || "").trim();
  const lat = latitude != null ? String(latitude).trim() : "";
  const lng = longitude != null ? String(longitude).trim() : "";
  if (!nextLabel || !lat || !lng) return;
  if (!Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ label: nextLabel, latitude: lat, longitude: lng })
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function initialMarketplaceLocationState() {
  const persisted = readPersistedMarketplaceLocation();
  if (persisted) {
    return {
      locationLabel: persisted.label,
      coords: { latitude: persisted.latitude, longitude: persisted.longitude },
    };
  }
  return {
    locationLabel: DEFAULT_MARKETPLACE_LOCATION.label,
    coords: {
      latitude: String(DEFAULT_MARKETPLACE_LOCATION.latitude),
      longitude: String(DEFAULT_MARKETPLACE_LOCATION.longitude),
    },
  };
}
